var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"people\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3174 12.8938C34.1975 12.8738 34.0575 12.8738 33.9375 12.8938C31.1778 12.7938 28.9781 10.5341 28.9781 7.73445C28.9781 4.8748 31.2778 2.57507 34.1375 2.57507C36.9971 2.57507 39.2969 4.89479 39.2969 7.73445C39.2769 10.5341 37.0771 12.7938 34.3174 12.8938Z",
    stroke: "#012E40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.2564 27.4519C34.9961 27.9118 38.0157 27.4319 40.1355 26.0121C42.9551 24.1323 42.9551 21.0527 40.1355 19.1729C37.9957 17.7531 34.9361 17.2731 32.1964 17.7531",
    stroke: "#012E40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2572 12.8938C10.3772 12.8738 10.5171 12.8738 10.6371 12.8938C13.3968 12.7938 15.5965 10.5341 15.5965 7.73445C15.5965 4.8748 13.2968 2.57507 10.4372 2.57507C7.5775 2.57507 5.27777 4.89479 5.27777 7.73445C5.29777 10.5341 7.49751 12.7938 10.2572 12.8938Z",
    stroke: "#012E40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.3188 27.4519C9.57914 27.9118 6.5595 27.4319 4.43976 26.0121C1.6201 24.1323 1.6201 21.0527 4.43976 19.1729C6.5795 17.7531 9.63913 17.2731 12.3788 17.7531",
    stroke: "#012E40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.319 27.8321C22.199 27.8121 22.059 27.8121 21.939 27.8321C19.1793 27.7321 16.9796 25.4723 16.9796 22.6727C16.9796 19.813 19.2793 17.5132 22.139 17.5132C24.9986 17.5132 27.2984 19.833 27.2984 22.6727C27.2784 25.4723 25.0786 27.7521 22.319 27.8321Z",
    stroke: "#012E40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.1395 34.1311C24.9598 32.0113 19.7005 32.0113 16.5009 34.1311C13.6812 36.0108 13.6812 39.0905 16.5009 40.9702C19.7005 43.11 24.9398 43.11 28.1395 40.9702",
    stroke: "#012E40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat4);
export default __webpack_public_path__ + "static/media/cat4.3b3065b728ae200edfcec787472da53d.svg";
export { ForwardRef as ReactComponent };